/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import {
  setSelectedEventSeverityAction,
  setSelectedManagedObjectAction,
  setSelectedEventTypeAction,
  setSelectedEventTimeAction,
  resetEventFiltersAction,
  setSelectedHostNameAction,
  setSelectedMaintenanceModeAction,
  setParentKeyAction,
  setSelectedDeviceKpiAction,
  setSelectedDeviceStatusAction,
  setSelectedLabelsAction,
  setSelectedFromEventTimeAction,
  setSelectedToEventTimeAction,
  setIsDeviceDetailPageAction,
  setGeoRegionAction,
  setRegionFilterIdsAction,
} from "./actions";
import { IEventFilterState } from "../types";

const initialState: IEventFilterState = {
  selectedEventSeverity: "",
};

const alarmFilterSlice = createSlice({
  name: "alarmfilter",
  initialState,
  reducers: {
    setSelectedEventSeverity: setSelectedEventSeverityAction,
    setSelectedManagedObject: setSelectedManagedObjectAction,
    setSelectedEventType: setSelectedEventTypeAction,
    setSelectedEventTime: setSelectedEventTimeAction,
    setSelectedFromEventTime: setSelectedFromEventTimeAction,
    setSelectedToEventTime: setSelectedToEventTimeAction,
    resetEventFilters: resetEventFiltersAction,
    setSelectedHostName: setSelectedHostNameAction,
    setSelectedMaintenanceMode: setSelectedMaintenanceModeAction,
    setParentKey: setParentKeyAction,
    setSelectedDeviceKpiStatus: setSelectedDeviceKpiAction,
    setSelectedDeviceStatus: setSelectedDeviceStatusAction,
    setIsDeviceDetailPage: setIsDeviceDetailPageAction,
    setGeoRegion: setGeoRegionAction,
    setSelectedLabels: setSelectedLabelsAction,
    setRegionFilterIds: setRegionFilterIdsAction,
  }
});

export const AlarmFilterReducer = alarmFilterSlice.reducer;
export const {
  setSelectedEventSeverity,
  setSelectedManagedObject,
  setSelectedEventType,
  setSelectedEventTime,
  setSelectedFromEventTime,
  setSelectedToEventTime,
  resetEventFilters,
  setSelectedHostName,
  setSelectedMaintenanceMode,
  setParentKey,
  setSelectedDeviceKpiStatus,
  setSelectedDeviceStatus,
  setIsDeviceDetailPage,
  setGeoRegion,
  setSelectedLabels,
  setRegionFilterIds
} = alarmFilterSlice.actions;
